import { defineComponent, computed, openBlock, createBlock, resolveDynamicComponent, normalizeClass } from 'vue';
import * as index$1 from '../../node_modules/@heroicons/vue/24/outline/esm/index.mjs';
import * as index from '../../node_modules/@heroicons/vue/24/solid/esm/index.mjs';
import * as index$2 from '../../node_modules/@heroicons/vue/20/solid/esm/index.mjs';
import * as index$3 from '../../node_modules/@heroicons/vue/16/solid/esm/index.mjs';
import camelCase from '../../node_modules/lodash/camelCase.mjs';
import startCase from '../../node_modules/lodash/startCase.mjs';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Icon",
  props: {
    name: { default: "ellipsis-horizontal" },
    type: { default: "outline" }
  },
  setup(__props) {
    const props = __props;
    const iconTypes = {
      solid: index,
      outline: index$1,
      mini: index$2,
      micro: index$3
    };
    const component = computed(function() {
      return iconTypes[props.type][startCase(camelCase(props.name)).replace(/ /g, "") + "Icon"];
    });
    const classes = computed(() => {
      if (props.type === "mini") {
        return "w-5 h-5";
      }
      if (props.type === "micro") {
        return "w-4 h-4";
      }
      return "w-6 h-6";
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(component.value), {
        class: normalizeClass(classes.value)
      }, null, 8, ["class"]);
    };
  }
});

export { _sfc_main as default };
